import { BasicCommand } from "./BasicCommand";
/**
 * Created by vvurilla on 13.08.2014.
 *
 * To use first register a listener:
 * BasicController.getInstance().addEventListener( TestCaseInfoEvent.TEST_CASE_INFO_RECEIVED, onTestCaseInfoReceived );
 * Then send the request message to server:
 * BasicModel.smartfoxClient.sendMessage( BasicSmartfoxConstants.C2S_TEST_CASE_INFO, [testCaseID] );
 *
 */


import { BasicSmartfoxConstants } from "../BasicSmartfoxConstants";
import { error } from "../../../logging/error";
import {BasicController} from "../BasicController";
import {TestCaseInfoEvent} from "../../event/TestCaseInfoEvent";
import {CoreErrorIdConstants} from "@goodgamestudios/shared-constants";

export class TCICommand extends BasicCommand {

		/*final*/ protected get cmdId(): string {
        return BasicSmartfoxConstants.S2C_TEST_CASE_INFO;
    }

		/*final*/ public executeCommand(errorID: number, params: any[]): boolean {
        if (errorID == CoreErrorIdConstants.OK) {
            let paramsObj: Object = JSON.parse(params.pop());

            BasicController.getInstance().dispatchEvent(new TestCaseInfoEvent(TestCaseInfoEvent.TEST_CASE_INFO_RECEIVED, paramsObj));

            return true;
        }
        error("TCICommand received TestCaseInfo error: " + errorID.toString());

        return false;
    }
}

